export class BackupZeroEtlTableFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlTableFilter.attributeTypeMap;
    }
    constructor() {
    }
}
